import axios from 'axios'
import * as ConstantsBase from '../Constants/base'
import { environmentConfig } from '../Utility/Utility'

export const CleanersAdminSearchStore = async (AuthData,Authstr) => {
    const getUrl = environmentConfig();
    const requestUrl = getUrl + ConstantsBase.SearchStore+AuthData.UserId;
  
    try {
      const data = await axios({
        method: 'post',
        url: requestUrl,
        // data: AuthData.AuthSearchText,
        headers: { 'Content-Type': 'application/json;' ,Authorization :Authstr,SearchText:AuthData.SearchText },
        validateStatus: function (status) { return status >= 200 }
      })
      return data;
    }
  
    catch (e) {
      return e;
    }
  }